/**
 *
 */
import {getCurrentCommunity, getSiteNotices} from './config';
import {Modal} from 'bootstrap';
import setupAnimateOnScroll from './animate-on-scroll';


/**
 *
 * @type {number}
 */
let modalCounter = 0;


/**
 * show site notices set via WP Admin > Website Settings > Site Notices
 */
const setupSiteNotices = () =>
{
	const siteNotices = getSiteNotices();
	const startTime   = performance.now();

	if (siteNotices && siteNotices.length) {

		const siteNotice = siteNotices[0];

		fetch( siteNotice.url )
			.then( response => response.text() )
			.then( html =>
			{
				const wait = siteNotice.delay - performance.now() - startTime;

				siteNotice.html = html;

				if (wait > 0) {
					setTimeout( () => showSiteNotice( siteNotice ), wait );
				} else {
					showSiteNotice( siteNotice );
				}
			} );
	}

	replaceCurrentCommunityVars();
};


/**
 *
 * @param {SiteNotice} siteNotice
 */
const showSiteNotice = ( siteNotice ) =>
{
	const currentCommunity = getCurrentCommunity();
	const modalId          = 'site-notice-modal-' + modalCounter;
	const insert           = `
		<div class="site-notice ${siteNotice.template}">
			<div class="modal fade" tabindex="-1" id="${modalId}">
				<div class="modal-dialog modal-dialog-centered">
					<div class="modal-content">
						<div class="modal-header">
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							${siteNotice.html}
						</div>
					</div>
				</div>
			</div>
		</div>
	`;

	document.body.innerHTML += insert;
	modalCounter++;

	// delay so that styles have time to be applied by the browser / avoid FOUT

	setTimeout( () =>
	{
		const modalElem = document.getElementById( modalId );
		const modal     = new Modal( modalElem );

		modal.show();

		// for some reason modals appear to remove the IntersectionObservers applied by setupAnimateOnScroll() - reapply on modal close

		modalElem.addEventListener( 'hidden.bs.modal', () => setupAnimateOnScroll() );

	}, 50 );

	// if this notice is showing from a community page, modify all site notice links to include the name of the community

	if (currentCommunity) {

		const links = document.querySelectorAll( '#' + modalId + ' .modal-body a' );

		links.forEach( link =>
		{
			link.href = link.href + '?community-name=' + encodeURIComponent( currentCommunity.name )
		} );
	}
};


/**
 * if we're coming from a site notice link that includes community info, replace text elements with a data-replace-XXX attribute with the relevant community information, i.e. <span data-replace-community-name></span> would show the community name if a 'community-name' query param is present
 */
const replaceCurrentCommunityVars = () =>
{
	const params = new URLSearchParams( location.search );

	params.forEach( ( value, key ) =>
	{
		const elements = document.querySelectorAll( '[data-replace-' + key + ']' );

		elements.forEach( elem => elem.textContent = value );
	} );
};


/**
 *
 */
export default setupSiteNotices;